import {Component, Input, OnInit} from '@angular/core';
import {sprintf} from "sprintf-js";
import {ComplexObject} from "../CardStruct";
import {VariableDataBase} from "../../variableDataBase/variable-data-base.service";
import {VariableValue} from "../../variableDataBase/VariableValue";

@Component({
  selector: 'app-card-gauge',
  templateUrl: './card-gauge.component.html',
  styleUrls: ['./card-gauge.component.css']
})
export class CardGaugeComponent implements OnInit {
  @Input() complexObject: ComplexObject = new ComplexObject();
  measurement: &VariableValue = new VariableValue();
  setting: &VariableValue = new VariableValue();


  constructor(private variableDB: VariableDataBase) {
  }

  ngOnInit(): void {
    this.measurement = this.variableDB.AddValueByReference(this.complexObject.actual.variable.id);
    this.setting = this.variableDB.AddValueByReference(this.complexObject.target.variable.id);
  }

  GetDescription():string
  {
    return this.complexObject.actual.variable.text;
  }

  GetUnit(): string {
    return this.complexObject.actual.variable.unit;
  }

  GetNumberOfUnitsOnScale() : number
  {
    return Math.floor(( this.GetScaleMax() - this.GetScaleMin()) / 5);
  }

  GetScaleMin():number{
    return this.complexObject.scale.minScale;
  }

  GetScaleMax():number{
    return this.complexObject.scale.maxScale;
  }


  GetValueAsString(): string {
    // The value we received is already a float. But we dont
    // want more number that specified in the precision
    switch (this.complexObject.actual.variable.precision) {
      case 4:
        return sprintf("%2.4f", this.measurement.val / 1);
      case 3:
        return sprintf("%3.3f", this.measurement.val / 1);
      case 2:
        return sprintf("%4.2f", this.measurement.val / 1);
      case 1:
        return sprintf("%5.1f", this.measurement.val / 1);
      case 0:
        return sprintf("%6f", this.measurement.val / 1);
      default:
        return sprintf("%6f", this.measurement.val / 1);
    }
  }


}
